import React from 'react';
import PageHeader from '@app/component/page/PageHeader';
import FlexiSetPage from '@app/site/secured/rateshopper/rates/dashboard/fragment/__flexi-sets/page/FlexiSetPage';

const CreateFlexiSetPage = React.memo(() => {

	return <div className="min-h-full bg-gray-100">
		<PageHeader link="/secured/rateshopper/rates/flexi-sets">Flexi Sets</PageHeader>
		<FlexiSetPage title="New Set" />
	</div>;
});

export default CreateFlexiSetPage;
